import { IPhone, IRequestPhone } from "types";

/* Форматирование поля номера телефона из поля str_number из формата 9113332211 в (911) 333-22-11*/
export const formatStrNumber = (phone: string): string => {
  //TODO: код номера пока не подставляется т.к. не ясно будет ли там всегда +7
  if (phone) {
    let a = phone.split('');
    a.splice(3, 0, ') ');
    a.splice(7, 0, '-');
    a.splice(10, 0, '-');
    a.unshift('(');
    return a.join('');
  } else {
    return '';
  }
};

/* Форматирование поля номера телефона из поля str_number из формата 89113332211 в 8 (911) 333-22-11*/
export const formatStrNumberWithCode = (phone: string): string => {
  let formatedPhone = phone.split('');
  formatedPhone.splice(1, 0, ' (');
  formatedPhone.splice(5, 0, ') ');
  formatedPhone.splice(9, 0, '-');
  formatedPhone.splice(12, 0, '-');
  return formatedPhone.join('');
};

/* Убирает все символы кроме цифр из строки */
export const onlyNumbersFromStr = (string: string): string => {
  return string.replace(/\D/g, '');
};

/* Разбивает номер телефона на код и номер (объект) */
export const splitPhone = (phone: string): { number: string; code: string } => {
  return {
    code: phone.slice(0, 3) || '',
    number: phone.slice(3) || '',
  };
};

/* Парсит значение маски телефона в code и number (поддерживает +7 и старый формат) */
export const parseMaskedPhoneToCodeNumber = (
  maskedValue: string
): { code: string; number: string } => {
  let digits = maskedValue.replace(/\D/g, '');

  if (digits.startsWith('7') && digits.length >= 10) {
    digits = digits.slice(1);
  }

  return {
    code: digits.slice(0, 3),
    number: digits.slice(3, 10),
  };
};

/* Оставляет короткий номер неизменным, например 2101, а полноценный приводит к формату +7 (999) 555-44-22 */
export const formatPhoneByLength = (phone: string): string => {
  if (phone.length === 7) {
    let a = phone.split('');
    a.splice(3, 0, '-');
    a.splice(6, 0, '-');
    return a.join('');
  } else if (phone.length < 10) {
    return phone;
  } else {
    return `+7 ${formatStrNumber(phone)}`;
  }
};

export const concatPhone = (code: string, number: string): string => {
  return code + number || '';
};

// Преобразует формат телефона из заявки в IPhone
export const normalizePhone = (phone: IPhone | IRequestPhone) => {
  if ('phone_type' in phone) {
    return phone;
  }

  return {
    number: phone.number,
    add: phone.add,
    added_by_tenant: false,
    code: '',
    id: null,
    not_actual: false,
    phone_type: phone._type,
    str_number: null,
    viber: null,
    whatsapp: null,
    telegram: null,
  };
};